define(['app/modules/forms', 'app/modules/preferences_selects'], (Forms, PreferencesSelects) => {
  const checkEmploymenType = function (employmentType) {
    if (employmentType == 'Permanent') {
      $('#job_length').val(null).addClass('hidden');
    } else {
      $('#job_length').removeClass('hidden');
    }
  };

  const addCustomQuestion = function () {
    const custom_question_count = $('.custom_question').length;
    const url = $('#custom_questions').data('url');

    $.ajax({
      type: 'GET',
      url: (url + custom_question_count),
      success(result) {
        const $addedItem = $(result.custom_fields_html).appendTo('#custom_questions > ul')
          .addClass('edit')
          .data('isNew', 1);
        $addedItem.find('input.checkbox-icheck').iCheck({ handle: 'checkbox' });
        $addedItem.find('input.radio-icheck').iCheck({ handle: 'radio' }).on('ifChecked', onIfChecked);
        $($addedItem.find('.form-control__max-words')[0]).prop('disabled', true);

        checkListQuestion();
      }
    });
  };

  var onIfChecked = function () {
    const inptEl = $(this);
    const max_words = $(inptEl.parents('.custom_question').find('.form-control__max-words')[0]);
    max_words.prop('disabled', !!(inptEl.val() != 'text'));
  };

  var checkListQuestion = function () {
    const items = $('#custom_questions > ul > li');

    for (let i = 0, len = items.length - 1; i < len; i++) {
      const item = $(items[i]);


      const nextItem = $(items[i + 1]);

      if (item.hasClass('edit') && nextItem.hasClass('edit')) {
        item.addClass('none-bottom-border');
      } else {
        item.removeClass('none-bottom-border');
      }
    }
  };

  const removeCustomQuestion = function (link) {
    link.parents('.custom_question').remove();
    checkListQuestion();
    $('#customQuestionsList .custom_question').each(function (index) {
      $(this).find('.index').html(index + 1);
    });
  };

  const saveJob = function (form) {
    const input = $('<input>').attr('type', 'hidden').attr('name', 'save').val('true');
    form.append(input);
    form.submit();
  };

  const updateBoardCountry = function (country) {
    $('.edit-job-advertising .tab-pane.active').removeClass('active');
    $(`.edit-job-advertising .tab-pane#${country}`).addClass('active');
  };

  const initMembersForm = function () {
    $('.job-members #members-select').chosen({ disable_search_threshold: 10, width: 'auto' }).on('change', function () {
      addMember($('#new_company_members_form'), $(this).val());
    });

    $('.job-members .members-form-group').on('click', (event) => {
      const membersForm = $(event.target).parents('form');
      const memberId = $(event.target).data('id');
      const isRemoveMemberLink = $(event.target).hasClass('remove-member');

      if (isRemoveMemberLink) {
        prepareFormForDeletion(membersForm, memberId);
      }
    });
  };

  var prepareFormForDeletion = function (form, memberId) {
    $(`.job-members #destroy_user_${memberId}`).val(1);

    submitForm(form, memberId);
  };

  const resetFormDestroyInput = function (form, memberId) {
    $(`.job-members #destroy_user_${memberId}`).val(0);
  };

  var submitForm = function (form, memberId = '', formData) {
    if (typeof formData === 'undefined') {
      formData = form.serialize();
    }

    $.ajax({
      type: 'PUT',
      url: form.attr('action'),
      data: formData,
      dataType: 'JSON',
      success(result) {
        Forms.hideErrors(form);

        if (result.errors_html) {
          Forms.showErrors(form, [], '', result.errors_html);

          if (memberId != '') {
            resetFormDestroyInput(form, memberId);
          }
        } else if (result.form_html) {
          $('.members-form').html(result.form_html);
          initMembersForm();
        }
      }
    });
  };

  var addMember = function (form, id) {
    const formData = {
      company_members_form: {
        job_users_attributes: {
          0: {
            user_id: id,
            _destroy: 0,
          }
        }
      }
    };

    submitForm(form, id, formData);
  };

  const addChoiceOption = function (option, choice_options_wrapper) {
    if (option) {
      const choice_options = choice_options_wrapper.find('.choice_options');
      const example_option = choice_options.find('.choice_option.example');
      const option_html = example_option.clone();
      option_html.find('input').attr({ value: option, name: option_html.attr('data-name') });
      option_html.removeClass('example hidden');
      choice_options.append(option_html);
      choice_options_wrapper.find('input#new_choice_options').val('');
    }
  };

  const removeChoiceOption = function (link) {
    link.parents('.choice_option').remove();
  };

  const showExternalUrl = function () {
    const urlInput = $('.external-url__input');
    if (urlInput.val() == '') {
      urlInput.toggleClass('hidden');
    } else {
      urlInput.removeClass('hidden');
    }
  };

  const initSuggestions = function () {
    new PreferencesSelects();
  };

  return {
    addCustomQuestion,
    removeCustomQuestion,
    onIfChecked,
    saveJob,
    checkListQuestion,
    updateBoardCountry,
    initMembersForm,
    prepareFormForDeletion,
    checkEmploymenType,
    addChoiceOption,
    removeChoiceOption,
    showExternalUrl,
    initSuggestions
  };
});
